import React from 'react';
import styled from 'styled-components';
import { CloseIcon } from '@ui/svgs/CloseIcon';
import { makeExternalUrl } from '../../../../lib/utils';
import { DOM_ONBOARDING_MODAL } from '../../../../lib/constants';
import { mapBackendButtonToFEButton } from '../../../../lib/helpers/button.helpers';
import Button from '../Button/Button';

const ModalContainerDiv = styled.div`
  position: relative;
  max-width: ${({ theme }) => theme.unit(70)};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: ${({ theme }) => theme.radius.lg};
  ${({ theme }) => theme['elevation-shadow']['3']}
  background-color: ${({ theme }) => theme.c.bg.primary};

  
  padding: ${({ theme }) => theme.unit(3)} ${({ theme }) => theme.unit(2)};
  
  @media (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
    padding: ${({ theme }) => theme.unit(6)} ${({ theme }) => theme.unit(3)};
  }
`;

const ModalHeaderDiv = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.unit(3)};
  padding: 0 ${({ theme }) => theme.unit(3)};

  @media (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
    margin-bottom: ${({ theme }) => theme.unit(4)};
  }
`;

const ModalHeaderLogoImg = styled.img`
  width: 100%;
  max-height: ${({ theme }) => theme.unit(12)};
`;

const ModalHeading = styled.h3`
  ${({ theme }) => theme.typographyRebrand.heading['2xl']}
  color: ${({ theme }) => theme.c.text.primary};
  margin: 0 0 ${({ theme }) => theme.unit(2)};
  text-align: center;
`;

const ModalSubHeading = styled.p`
  ${({ theme }) => theme.typographyRebrand.body.md}
  color: ${({ theme }) => theme.c.text.primary};
  margin-bottom: ${({ theme }) => theme.unit(3)};
  text-align: center;
`;

const BottomBannerButtonDiv = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.unit(2)};
  flex-direction: column;
  
  @media (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
    flex-direction: row;
    justify-content: center;
  }
`;

const CloseButton = styled.button`
  appearance: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  cursor: pointer;
  position: absolute;
  top: ${({ theme }) => theme.unit(2)};
  right: ${({ theme }) => theme.unit(2)};

  svg {
    display: block;
  }
`;

const OnboardingModal = (props) => {
  const {
    onboardingModalData = {},
    locale = 'en',
    closeModal = () => {},
  } = props;

  const {
    buttonText = '',
    secondaryButton,
    headerText = '',
    headerTextLogo = '',
    subHeaderText = '',
    bottomBannerSubHeaderText = '',
  } = onboardingModalData;

  const headerTextLogoToUse = makeExternalUrl(headerTextLogo);
  const mappedSecondaryButton = mapBackendButtonToFEButton({
    button: secondaryButton,
    locale,
    analyticsParentId: DOM_ONBOARDING_MODAL,
    fallback: {
      buttonText,
      variant: 'secondary',
      size: 'medium',
      theme: 'light',
    },
  });

  return (
    <ModalContainerDiv>
      <CloseButton>
        <CloseIcon onClick={closeModal} />
      </CloseButton>

      <ModalHeaderDiv>
        <ModalHeaderLogoImg src={headerTextLogoToUse} />
      </ModalHeaderDiv>

      <ModalHeading>{headerText}</ModalHeading>
      <ModalSubHeading>{subHeaderText}</ModalSubHeading>

      {bottomBannerSubHeaderText && (
        <ModalSubHeading>{bottomBannerSubHeaderText}</ModalSubHeading>
      )}

      <BottomBannerButtonDiv>
        <Button
          variant="primary"
          size="medium"
          theme="light"
          onClick={closeModal}
          buttonText={buttonText}
        />

        {mappedSecondaryButton && (
          <Button
            {...mappedSecondaryButton}
          />
        )}
      </BottomBannerButtonDiv>
    </ModalContainerDiv>
  );
};

export default OnboardingModal;
